// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1tqGB","footer":"ModalUpdate_footer__3_yWG"};